import { Col } from '@repo/ui/components'
import { cn } from '@repo/ui/lib'
import type { CSSVariableBreakpointToken } from '@repo/ui/types'

interface IDashboardLayoutProps {
  children: React.ReactNode
  footer?: React.ReactNode
  header?: React.ReactNode
  sidebar?: React.ReactNode
  subHeader?: React.ReactNode
  subBgHeader?: React.ReactNode
  screenMaxWidth?: CSSVariableBreakpointToken
  asideMaxWidth?: CSSVariableBreakpointToken
}

export const DashboardLayout = (props: IDashboardLayoutProps) => {
  const {
    children,
    footer,
    header,
    sidebar,
    subHeader,
    subBgHeader,
    screenMaxWidth = 'md',
    asideMaxWidth = '5xs',
  } = props
  const screenMaxWidthClass = (
    {
      '5xs': 'max-w-screen-5xs',
      '4xs': 'max-w-screen-4xs',
      '3xs': 'max-w-screen-3xs',
      '2xs': 'max-w-screen-2xs',
      xs: 'max-w-screen-xs',
      sm: 'max-w-screen-sm',
      md: 'max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      full: 'max-w-screen-full',
    } satisfies Record<CSSVariableBreakpointToken, string>
  )[screenMaxWidth]
  const asideMaxWidthClass = (
    {
      '5xs': 'md:max-w-screen-5xs',
      '4xs': 'md:max-w-screen-4xs',
      '3xs': 'md:max-w-screen-3xs',
      '2xs': 'md:max-w-screen-2xs',
      xs: 'md:max-w-screen-xs',
      sm: 'md:max-w-screen-sm',
      md: 'md:max-w-screen-md',
      lg: 'max-w-screen-lg',
      xl: 'max-w-screen-xl',
      full: 'max-w-screen-full',
    } satisfies Record<CSSVariableBreakpointToken, string>
  )[asideMaxWidth]
  return (
    <Col className={cn('min-h-screen  relative', 'bg-neutral-surface-light')}>
      {header && (
        <header
          className={cn('sticky top-0 w-full z-20', 'bg-neutral-surface-light')}
        >
          {header}
        </header>
      )}
      {subBgHeader}
      {subHeader && (
        <div className={`flex w-full ${screenMaxWidthClass} mx-auto gap-md `}>
          {subHeader}
        </div>
      )}
      <div
        className={`flex flex-col md:flex-row w-full flex-1 ${screenMaxWidthClass} mx-auto gap-md pt-0 sm:pt-md`}
      >
        {sidebar && (
          <aside
            className={`w-full ${asideMaxWidthClass} p-md md:p-0 md:sticky md:top-16 md:h-[calc(100vh-4rem)]`}
          >
            {sidebar}
          </aside>
        )}
        <main className='flex-1 w-full p-md md:p-0'>{children}</main>
      </div>

      {footer && <footer>{footer}</footer>}
    </Col>
  )
}
